import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import ErrorPage from "@/views/ErrorPage";
import AccessDeniedPage from "@/views/AccessDeniedPage";
import Login from "@/views/login/Login";
import store from '../store/index';
import CreateOffer from "../views/CreateOffer";
import Splash from "@/views/Splash";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {requiresLogin: true}
  },
  {
    path: '/error',
    name: 'Error',
    component: ErrorPage,
    meta: {requiresLogin: false}
  },
  {
    path: '/denied',
    name: 'AccessDenied',
    component: AccessDeniedPage,
    meta: {requiresLogin: false}
  },
  {
    path: '/splash',
    name: 'Splash',
    component: Splash,
    meta: {requiresLogin: false}
  },
  {
    path: '/signin',
    name: 'Login',
    component: Login,
    meta: {requiresLogin: false}
  },
  {
    path: '/offer/:offerId',
    name: 'CreateOffer',
    component: CreateOffer,
    meta: {requiresLogin: false},
    props: {offerId: ""}
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    meta: {requiresLogin: true}
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {

  /*
  * Die Fehlerseite muss immer erreichbar sein.
   */
  if (to.matched.some(record => record.path === '/error')) {
    next();
    return;
  }

  if (!store.state.config.configurationLoaded && to.matched.some(record => record.path !== '/splash')) {
    next('/splash')
    return;
  }

  if (to.matched.some(record => record.meta.requiresLogin) && (!store.state.auth.isAuthenticated)) {
    next('/signin');
  } else {
    next();
  }

  /*
    if (to.matched.some(record => record.path === '/signin') && store.state.auth.isAuthenticated) {
      next('/');
      return;
    }
    if (to.matched.some(record => record.meta.requiresLogin) && (!store.state.auth.isAuthenticated)) {
      next('/signin');
    } else {
      next();
    }

   */
})

export default router
